// Get Sendbird Batch Message Info
export const GET_SENDBIRD_BATCH_MESSAGE_INFO_REQUEST = 'GET_SENDBIRD_BATCH_MESSAGE_INFO_REQUEST';
export const GET_SENDBIRD_BATCH_MESSAGE_INFO_DONE = 'GET_SENDBIRD_BATCH_MESSAGE_INFO_DONE';
export const GET_SENDBIRD_BATCH_MESSAGE_INFO_FAILED = 'GET_SENDBIRD_BATCH_MESSAGE_INFO_FAILED';